import React from 'react';
import clsx from 'clsx';
import { Label, Table } from 'semantic-ui-react';
import { filterWithMinimumLength, removeDuplicates } from '@/utils/resultsHelper';

const LabelsCell = ({ labels, title, className }) => {
  const values = removeDuplicates(filterWithMinimumLength(labels || []), true);
  return (
    <Table.Cell className={clsx('aridhia-labels-cell', className)} title={title}>
      {values.length > 0 && (
        <Label.Group className="aridhia-tag">
          {values.map((i) => (<Label key={i} content={i} />))}
        </Label.Group>
      )}
    </Table.Cell>
  );
};

export default LabelsCell;
